import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const MAANDEN = [
  "januari", "februari", "maart", "april", "mei", "juni",
  "juli", "augustus", "september", "oktober", "november", "december",
];
const WEEKDAGEN = ["Ma", "Di", "Wo", "Do", "Vr", "Za", "Zo"];

const NEXT = { leeg: "beschikbaar", beschikbaar: "niet_beschikbaar", niet_beschikbaar: "leeg" };

const fmt = (y, m, d) => `${y}-${String(m + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

export default function AvailabilityCalendar({ agenda = {}, editable = false, onSet }) {
  const [cursor, setCursor] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const startWeekday = (new Date(year, month, 1).getDay() + 6) % 7; // maandag = 0
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const today = new Date(); today.setHours(0, 0, 0, 0);

  const move = (delta) => setCursor(new Date(year, month + delta, 1));

  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const statusCls = {
    beschikbaar: "bg-green-500 text-white border-green-500 hover:bg-green-600",
    niet_beschikbaar: "bg-red-500 text-white border-red-500 hover:bg-red-600",
    leeg: "bg-white text-slate-700 border-slate-200 hover:border-slate-400",
  };

  return (
    <div data-testid="availability-calendar" className="bg-white border border-slate-200 rounded-md p-5 max-w-md">
      <div className="flex items-center justify-between mb-4">
        <button data-testid="cal-prev" onClick={() => move(-1)} className="w-8 h-8 flex items-center justify-center rounded-sm border border-slate-200 hover:bg-slate-50">
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="font-display font-bold text-slate-950 capitalize">{MAANDEN[month]} {year}</span>
        <button data-testid="cal-next" onClick={() => move(1)} className="w-8 h-8 flex items-center justify-center rounded-sm border border-slate-200 hover:bg-slate-50">
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      <div className="grid grid-cols-7 gap-1.5 mb-1.5">
        {WEEKDAGEN.map((w) => (
          <div key={w} className="text-center text-[0.65rem] font-bold uppercase tracking-wide text-slate-400">{w}</div>
        ))}
      </div>

      <div className="grid grid-cols-7 gap-1.5">
        {cells.map((d, i) => {
          if (d === null) return <div key={`b${i}`} />;
          const ds = fmt(year, month, d);
          const status = agenda[ds] || "leeg";
          const cellDate = new Date(year, month, d);
          const isPast = cellDate < today;
          const isToday = cellDate.getTime() === today.getTime();
          const clickable = editable && !isPast;
          return (
            <button
              key={ds}
              data-testid={`cal-day-${ds}`}
              disabled={!clickable}
              onClick={() => clickable && onSet(ds, NEXT[status])}
              className={`aspect-square rounded-sm border text-sm font-semibold transition-colors duration-150 ${statusCls[status]} ${isPast ? "opacity-40 cursor-default" : clickable ? "cursor-pointer" : "cursor-default"} ${isToday ? "ring-2 ring-orange-500 ring-offset-1" : ""}`}
            >
              {d}
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-4 mt-4 text-xs text-slate-600">
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-green-500 inline-block" /> Beschikbaar</span>
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-red-500 inline-block" /> Niet beschikbaar</span>
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-white border border-slate-300 inline-block" /> Niet ingesteld</span>
      </div>
      {editable && (
        <p className="text-xs text-slate-400 mt-3">Klik op een dag om te wisselen: leeg → beschikbaar → niet beschikbaar.</p>
      )}
    </div>
  );
}
